import React from "react";
import ReactDOM from "react-dom/client";
import ModeProvider from "@utils/ModeContext";
import App from "./App";
import { ROOT_ID } from "./constants";

const rootElement = document.getElementById(ROOT_ID);

if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <ModeProvider
        value={
          rootElement.dataset.mode === "admin" ||
          import.meta.env.VITE_ADMIN_ON === "true"
        }
      >
        <App />
      </ModeProvider>
    </React.StrictMode>
  );
}
